import { useState } from "react";

import FormFields from "../components/FormFields";
import euserConfig from "../data/euserConfig"; // Form config
import { FormDataType } from "../types";
import { notify } from "../utils/notify";
import useEuser from "../utils/useEuser"; // access to provider via "use" hook

export const AccountRecover = () => {
  const { recoverEuser } = useEuser();

  const [formData, setFormData] = useState<FormDataType>(
    euserConfig.recoverFields.reduce(
      (prev, field) => ({
        ...prev,
        [field.fieldName]: "",
      }),
      {}
    )
  );

  const afterPostFunction = async () => {
    notify.persistToast({
      message:
        "Recovery process has been initiated. Please check your email for next step instructions.",
      type: "info",
    });
    window.location.reload();
  };

  return (
    <div className="editPageWrapper">
      <h3 className="list_title">Account Recover</h3>

      <FormFields
        fields={euserConfig.recoverFields}
        form={{ method: "post", data: formData }}
        setFormData={(_, data) => setFormData(data)}
        formMode={"post"}
        name={euserConfig.name}
        onPostFunction={recoverEuser}
        afterPostFunction={afterPostFunction} // Not used here, needs cleanup
      />
    </div>
  );
};
